import {FilterableColumn, ColumnType} from 'src/tracker/model/column/tracker-column'
import { CrystalColor } from 'src/forecast/model/universal-data-model'
import { crystalColorProperty } from '../../property/static/crystal-color-property'

export const crystalColorColumn = new FilterableColumn<CrystalColor>(
  "45px",
  ColumnType.COLOR,
  crystalColorProperty
)
